import "./FilterSchool.css";
// import { IoSearch } from "react-icons/io5";
// import { SiMicrosoftexcel } from "react-icons/si";

const FilterCollege = () => {
  return (
    <>
      <div className="college-all-course-inner-main-wrapper">
        <div className="headertable">
          <h5>School</h5>
          <table>
            <thead>
              <tr>
                <th>Class</th>
                <th>Subject</th>
                <th>Chapter</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Class 1</td>
                <td>English</td>
                <td>7</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
              <tr>
                <td>Class 7</td>
                <td>Math</td>
                <td>7</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
              <tr>
                <td>Class 3</td>
                <td>science</td>
                <td>7</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
              <tr>
                <td>Class 3</td>
                <td>Math</td>
                <td>7</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
              <tr>
                <td>Class 2</td>
                <td>Sst</td>
                <td>7</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
              <tr>
                <td>Class 3</td>
                <td>Math</td>
                <td>7</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
              <tr>
                <td>Class 5</td>
                <td>Math</td>
                <td>7</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
              <tr>
                <td>Class 9</td>
                <td>Math</td>
                <td>7</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
              <tr>
                <td>Class 4</td>
                <td>Math</td>
                <td>7</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
              <tr>
                <td>Class 6</td>
                <td>Math</td>
                <td>7</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default FilterCollege;
